module.exports = __webpack_public_path__ + "static/img/bussinessImg4.7dd10f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bussinessImg4.jpg
// module id = VQGN
// module chunks = 1